<template>
  <div class="help-page">
    <UEditor v-model="content"></UEditor>

    <div class="submit">
      <Button @click="setQues" size="large" type="primary">保存</Button>
    </div>
  </div>
</template>

<script>
import UEditor from "@/components/UEditor.vue";
export default {
  name: "WithdrawQues",
  components: {
    UEditor
  },
  data() {
    return {
      content: ""
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      let data = await this.$http.get(`/api/commonProblems`);
      this.content = data.common_problems;
    },
    setQues() {
      this.$http
        .post(`/api/commonProblems`, {
          common_problems: this.content
        })
        .then(() => {
          this.$Message.success("成功");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.help-page {
  padding: 10px;
}
.submit {
  margin-top: 20px;
  text-align: right;
}
</style>
